"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TextareaInput = void 0;
const react_1 = __importDefault(require("react"));
require("./styles.scss");
const TextareaInput = (props) => {
    const { name, className = "", label, handleChange, value, placeholder, error } = props;
    const onChange = (e) => handleChange === null || handleChange === void 0 ? void 0 : handleChange(e.target.value);
    return (react_1.default.createElement("div", { className: "c-textarea-field" },
        label && (react_1.default.createElement("label", { htmlFor: name, className: "c-textarea-field__label" }, label)),
        react_1.default.createElement("div", { className: "c-textarea-field__input-container" },
            react_1.default.createElement("textarea", { onChange: onChange, value: value, name: name, placeholder: placeholder, className: `c-textarea-field__input ${className}`, rows: 2 })),
        error && react_1.default.createElement("div", { className: "c-textarea-field__validation" }, error)));
};
exports.TextareaInput = TextareaInput;
